import { render, staticRenderFns } from "./PostsListWidget.vue?vue&type=template&id=0d0e85b4&scoped=true"
import script from "./PostsListWidget.vue?vue&type=script&lang=js"
export * from "./PostsListWidget.vue?vue&type=script&lang=js"
import style0 from "./PostsListWidget.vue?vue&type=style&index=0&id=0d0e85b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0e85b4",
  null
  
)

export default component.exports